import { lazy } from 'react';
import { createBrowserRouter, RouterProvider, RouteObject } from 'react-router';
import {
  ErrorPage,
  RouteErrorBoundary,
  SuspenseLayout,
} from '@antecipa/core/components';

const ResetPasswordFactory = lazy(() =>
  import('application/factories/reset-password/reset-password.factory').then((m) => ({
    default: m.ResetPasswordFactory,
  })),
);
const SignupFactory = lazy(() =>
  import('application/factories/signup/signup.factory').then((m) => ({ default: m.SignupFactory })),
);
const Challenge = lazy(() => import('presentation/pages/Challenge'));
const Logout = lazy(() =>
  import('presentation/pages/Logout/logout.component').then((m) => ({ default: m.Logout })),
);
const RedirectComponent = lazy(() =>
  import('presentation/pages/Redirect/redirect.component').then((m) => ({
    default: m.RedirectComponent,
  })),
);
const RequestResetPassword = lazy(() => import('presentation/pages/RequestResetPassword'));
const RequestSignInOTP = lazy(() => import('presentation/pages/RequestSignInOtp'));
const SignInOtpComponent = lazy(() =>
  import('presentation/pages/SignInOtp/sign-in-otp.component').then((m) => ({
    default: m.SignInOtpComponent,
  })),
);
const SignIn = lazy(() =>
  import('presentation/pages/SignIn/sign-in.component').then((m) => ({ default: m.SignIn })),
);
const CorporateCallbackRedirect = lazy(() =>
  import('presentation/pages/CorporateCallbackSignIn/corporateCallbackRedirect.component').then(
    (m) => ({ default: m.CorporateCallbackRedirect }),
  ),
);
const CorporateLogin = lazy(() =>
  import('presentation/pages/CorporateLogin/corporateLogin.component').then((m) => ({
    default: m.CorporateLogin,
  })),
);
const Unsubscribe = lazy(() =>
  import('presentation/pages/Unsubscribe/unsubscribe.component').then((m) => ({
    default: m.Unsubscribe,
  })),
);


const routes: RouteObject[] = [
  {
    ErrorBoundary: RouteErrorBoundary,
    children: [
      {
        element: <SuspenseLayout />,
        children: [
          { index: true, element: <SignIn /> },
          { path: 'sign-in-otp', element: <SignInOtpComponent /> },
          { path: 'request-sign-in-otp', element: <RequestSignInOTP /> },
          { path: 'logout', element: <Logout /> },
          { path: 'redirect', element: <RedirectComponent /> },
          { path: 'callback', element: <CorporateCallbackRedirect /> },
          { path: 'challenge', element: <Challenge /> },
          { path: 'reset-password', element: <ResetPasswordFactory /> },
          {
            path: 'request-reset-password',
            element: <RequestResetPassword />,
          },
          { path: 'corporatelogin', element: <CorporateLogin /> },
          {
            path: 'signup',
            children: [
              { index: true, element: <SignupFactory /> },
              { path: 'review', element: <SignupFactory /> },
              { path: 'password', element: <SignupFactory /> },
              { path: 'email-validation', element: <SignupFactory /> },
            ],
          },
          { path: 'unsubscribe', element: <Unsubscribe /> },
          { path: '*', element: <ErrorPage errorCode="404" /> },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export function AppRoute() {
  return <RouterProvider router={router} useTransitions={false} />;
}
